import { cn } from "@/lib/utils";
import { ExtensionLink } from "components/core/ExtensionLink";
import { AppPage } from "models/AppPage";

interface DropdownItemProps {
    child: AppPage;
    isSelected: boolean;
    animationDelay: string;
}

/**
 * Individual dropdown menu item component
 * Displays a single navigation link with selection state and animations
 */
export const DropdownItem = ({
    child,
    isSelected,
    animationDelay
}: DropdownItemProps) => {
    return (
        <ExtensionLink
            href={child.href}
            className="group/item relative cursor-pointer overflow-hidden
                rounded-lg"
            style={{
                animation: `fadeInUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) ${animationDelay} backwards`
            }}
        >
            <div
                className={cn(
                    "relative w-[130px] px-4 py-3 text-sm font-medium",
                    "rounded-xl transition-all duration-300 ease-out",
                    isSelected
                        ? "bg-black text-white dark:bg-white dark:text-black"
                        : `hover:bg-black/70 hover:text-white
                            dark:hover:bg-white/70 dark:hover:text-black`
                )}
            >
                <div
                    className="relative z-10 flex items-center justify-center
                        text-center tracking-normal"
                >
                    {child.label}
                </div>
            </div>
        </ExtensionLink>
    );
};
